import { render, staticRenderFns } from "./CurrencyList.vue?vue&type=template&id=352b0c3e&scoped=true"
import script from "./CurrencyList.vue?vue&type=script&lang=js"
export * from "./CurrencyList.vue?vue&type=script&lang=js"
import style0 from "./CurrencyList.vue?vue&type=style&index=0&id=352b0c3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b0c3e",
  null
  
)

export default component.exports